module.exports = __webpack_public_path__ + "media/images/menu/channel_1_off-50c501ad149a29cfb056114cce042e0e.jpg";